/**
 * Il nome dell'export del recorder: `rec-AAAA-MM-GG-HHMMSS`, in ora locale (quella che si legge sull'orologio in magazzino).
 * Prima era `rec-AAAA-MM-GG`: ogni export dopo il primo del giorno aveva lo stesso nome e Chrome chiedeva «Scaricare nuovamente il
 * file?»; finché non si rispondeva il file non usciva, e ogni pressione in coda ne produceva una copia. Con i secondi nel nome due
 * export distinti non si chiamano mai allo stesso modo. Lo script `scarica-export.ps1` cerca `rec-*.json`: il formato resta valido.
 */
export function exportName(now: Date): string {
  const p = (n: number): string => String(n).padStart(2, '0');
  return `rec-${now.getFullYear()}-${p(now.getMonth() + 1)}-${p(now.getDate())}-${p(now.getHours())}${p(now.getMinutes())}${p(now.getSeconds())}`;
}
